/* Mobile presentation only. Existing controls, state and purchase handlers stay intact. */
(function () {
  "use strict";

  if (window.PS_MOBILE_ORDER && typeof window.PS_MOBILE_ORDER.destroy === "function") {
    window.PS_MOBILE_ORDER.destroy();
  }
  if (typeof window.matchMedia !== "function") return;

  const media = window.matchMedia("(max-width: 760px)");
  const compactMedia = window.matchMedia("(max-width: 1024px)");
  const rootHadClassAttribute = document.documentElement.hasAttribute("class");
  const layouts = { home: null, catalog: null, studio: null, product: null, header: null };
  const listeners = [];
  let destroyed = false;
  let frame = 0;
  let productHost = null;
  let productObserver = null;

  function copy(key, fallback) {
    const value = window.PS_MOBILE_COPY && window.PS_MOBILE_COPY[key];
    return typeof value === "string" && value.trim() ? value : fallback;
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  /* Comment slots retain the precise original parent and sibling position. */
  function transaction(owner) {
    const moves = [];
    const moved = new Set();
    const additions = [];
    const cleanups = [];
    return {
      owner: owner,
      move: function (node, parent, before) {
        if (!node || !parent) return;
        if (!moved.has(node)) {
          const slot = document.createComment("ps-mobile-order-slot");
          node.parentNode.insertBefore(slot, node);
          moved.add(node);
          moves.push({ node: node, slot: slot });
        }
        parent.insertBefore(node, before || null);
      },
      add: function (node, parent, before) {
        parent.insertBefore(node, before || null);
        additions.push(node);
        return node;
      },
      className: function (node, name) {
        const existed = node.classList.contains(name);
        node.classList.add(name);
        if (!existed) cleanups.push(function () { node.classList.remove(name); });
      },
      attribute: function (node, name, value) {
        const previous = node.getAttribute(name);
        if (value === null) node.removeAttribute(name);
        else node.setAttribute(name, value);
        cleanups.push(function () {
          if (previous === null) node.removeAttribute(name);
          else node.setAttribute(name, previous);
        });
      },
      text: function (node, value) {
        const previous = node.textContent;
        node.textContent = value;
        cleanups.push(function () { node.textContent = previous; });
      },
      listen: function (node, event, callback) {
        node.addEventListener(event, callback);
        cleanups.push(function () { node.removeEventListener(event, callback); });
      },
      cleanup: function (callback) { cleanups.push(callback); },
      destroy: function () {
        cleanups.reverse().forEach(function (cleanup) { cleanup(); });
        moves.reverse().forEach(function (move) {
          if (move.slot.parentNode) {
            move.slot.parentNode.insertBefore(move.node, move.slot);
            move.slot.remove();
          }
        });
        additions.reverse().forEach(function (node) { node.remove(); });
      }
    };
  }

  function release(name) {
    if (layouts[name]) layouts[name].destroy();
    layouts[name] = null;
  }

  function clearRootClass() {
    document.documentElement.classList.remove("ps-mobile-order-active");
    if (!rootHadClassAttribute && !document.documentElement.getAttribute("class")) {
      document.documentElement.removeAttribute("class");
    }
  }

  function header() {
    const host = document.querySelector("header.header");
    if (layouts.header && layouts.header.owner !== host) release("header");
    if (!host || layouts.header) return;
    const search = host.querySelector(":scope > .search");
    const menu = host.querySelector(":scope > .mobile-menu");
    const nav = document.querySelector("nav.navigation");
    if (!search || !menu || !nav || !nav.parentNode) return;
    const tx = transaction(host);
    tx.className(host, "ps-mobile-compact-header");
    tx.className(nav, "ps-mobile-compact-navigation");
    tx.className(search, "ps-mobile-compact-search");
    tx.move(search, nav.parentNode, nav.nextSibling);
    tx.move(menu, nav, nav.firstChild);
    layouts.header = tx;
  }

  function home() {
    const host = document.getElementById("home-page");
    if (layouts.home && layouts.home.owner !== host) release("home");
    if (!host || layouts.home) return;
    const walkIn = host.querySelector(":scope > #walk-in");
    const shop = host.querySelector(":scope > #shop");
    const paths = host.querySelector(":scope > .paths");
    const craft = host.querySelector(":scope > #craft");
    if (!walkIn || !shop || !paths || !craft) return;
    const tx = transaction(host);
    tx.move(shop, host, walkIn);
    tx.move(paths, host, walkIn);
    tx.move(craft, host, walkIn);
    layouts.home = tx;
  }

  function catalog() {
    const host = document.querySelector("#collection-page .catalog");
    if (layouts.catalog && layouts.catalog.owner !== host) release("catalog");
    if (!host || layouts.catalog) return;
    const aside = host.querySelector(":scope > aside");
    const toolbar = host.querySelector(".catalog-toolbar");
    const summary = host.querySelector("#filter-summary");
    if (!aside || !toolbar) return;
    const tx = transaction(host);
    tx.className(host, "ps-mobile-catalog");
    tx.move(toolbar, host, aside);
    if (summary) tx.move(summary, host, aside);
    if (!aside.id) tx.attribute(aside, "id", "ps-mobile-catalog-filters");

    const toggle = element("button", "ps-mobile-filter-toggle");
    toggle.type = "button";
    toggle.setAttribute("aria-controls", aside.id);
    tx.add(toggle, toolbar);
    const originallyHidden = aside.hidden;
    let expanded = aside.contains(document.activeElement);
    function updateDisclosure() {
      aside.hidden = !expanded;
      toggle.setAttribute("aria-expanded", String(expanded));
      toggle.textContent = expanded ? copy("hideFilters", "Hide filters") : copy("filters", "Filters");
    }
    tx.listen(toggle, "click", function () {
      expanded = !expanded;
      updateDisclosure();
    });
    tx.cleanup(function () { aside.hidden = originallyHidden; });
    updateDisclosure();
    layouts.catalog = tx;
  }

  function textOptions(tx, art) {
    const panel = art.querySelector(".text-control");
    if (!panel) return;
    const selectors = [
      'label[for="embroidery-font"]', "#embroidery-font", "#text-preview-note",
      "#font-choice-sample", "#font-reference", 'label[for="thread-color"]',
      "#thread-color", ".thread-color-chips", "#thread-reference",
      ".thread-match-note", ".text-layout-controls", ".text-case-actions"
    ].join(",");
    const nodes = Array.from(panel.children).filter(function (node) { return node.matches(selectors); });
    const start = panel.querySelector(':scope > label[for="embroidery-font"]');
    if (!start || !nodes.length) return;
    const details = element("details", "ps-mobile-text-options");
    details.open = nodes.some(function (node) { return node.contains(document.activeElement); });
    const summary = element("summary", "", copy("textOptions", "Font, thread and text options"));
    const body = element("div", "ps-mobile-text-options-body");
    details.append(summary, body);
    tx.add(details, panel, start);
    nodes.forEach(function (node) { tx.move(node, body); });
  }

  function studio() {
    const host = document.querySelector("#studio-page .studio");
    if (layouts.studio && layouts.studio.owner !== host) release("studio");
    if (!host || layouts.studio) return;
    const panel = host.querySelector(":scope > .product-panel");
    const art = host.querySelector(":scope > .art-panel");
    const preview = host.querySelector(":scope > .preview-panel");
    const swatches = document.getElementById("studio-swatches");
    const sizes = document.getElementById("studio-size-controls");
    const price = document.getElementById("studio-price");
    const views = document.getElementById("preview-views");
    const locationControl = preview && preview.querySelector(":scope > #ps-embroidery-location-control");
    const quantity = panel && panel.querySelector(".qty-label");
    if (!panel || !art || !preview || !swatches || !sizes || !price || !views || !locationControl || !quantity) return;
    const tx = transaction(host);
    tx.className(host, "ps-mobile-studio");
    textOptions(tx, art);
    const colorLabel = panel.querySelector(".color-label");
    const optionNodes = [colorLabel, swatches, sizes, document.getElementById("studio-finish-controls")]
      .filter(function (node) { return node && panel.contains(node); });
    const options = element("section", "ps-mobile-product-options");
    const toggle = element("button", "ps-mobile-options-toggle");
    toggle.type = "button";
    toggle.setAttribute("aria-controls", "ps-mobile-studio-options");
    const label = element("span", "ps-mobile-options-label", copy("chooseHatColor", "Choose hat color"));
    const selected = element("span", "ps-mobile-selection-text");
    const icon = element("span", "ps-mobile-options-icon", "−");
    icon.setAttribute("aria-hidden", "true");
    toggle.append(label, selected, icon);
    const body = element("div", "ps-mobile-options-body");
    body.id = "ps-mobile-studio-options";
    options.append(toggle, body);
    tx.add(options, panel, optionNodes[0]);
    let expanded = true;
    optionNodes.forEach(function (node) { tx.move(node, body); });
    function updateDisclosure() {
      body.hidden = !expanded;
      toggle.setAttribute("aria-expanded", String(expanded));
      icon.textContent = expanded ? "−" : "+";
    }
    function updateSelection() {
      const color = document.getElementById("color-name");
      const size = sizes.querySelector("select");
      const option = size && size.options[size.selectedIndex];
      const values = [color && color.textContent.trim(), option && option.textContent.trim()].filter(Boolean);
      selected.textContent = values.join(" · ") || copy("productOptions", "Color & size");
    }
    tx.listen(toggle, "click", function () {
      expanded = !expanded;
      if (!expanded && body.contains(document.activeElement)) toggle.focus({ preventScroll: true });
      updateDisclosure();
    });
    tx.listen(panel, "change", updateSelection);
    const selectionObserver = new MutationObserver(updateSelection);
    [swatches, sizes, document.getElementById("color-name")].filter(Boolean).forEach(function (node) {
      selectionObserver.observe(node, { childList: true, subtree: true, characterData: true });
    });
    tx.cleanup(function () { selectionObserver.disconnect(); });
    updateDisclosure();updateSelection();
    const orderHeading = element("h3", "ps-mobile-order-heading", copy("orderSummary", "Quantity & review"));
    tx.add(orderHeading, panel, quantity);
    tx.move(preview, panel, orderHeading);
    tx.move(art, panel, orderHeading);
    if (locationControl) {
      const area = element("section", "ps-mobile-placement");
      const stage = preview.querySelector(":scope > #preview-stage");
      tx.add(area, preview, stage ? stage.nextSibling : preview.firstChild);
      // Its original slot stays below the photo when the desktop layout is restored.
      tx.move(locationControl, area);
      const tools = preview.querySelector(":scope > .studio-preview-tools");
      if (tools) tx.move(tools, area);
      const instruction = art.querySelector(":scope > p:not([id])");
      if (instruction) tx.text(instruction, copy("locationInstruction", "Choose an area above, then add your design."));
    }
    const textPanel = art.querySelector(".text-control"), applyRow = document.getElementById("studio-text-apply");
    if (textPanel && applyRow && preview.contains(applyRow)) tx.move(applyRow, art, textPanel.nextSibling);
    const bar = document.querySelector("#studio-page > .studio-bar");
    const progress = bar && bar.querySelector(":scope > div:not(.studio-design-actions)");
    if (progress) { tx.attribute(progress, "class", ((progress.getAttribute("class") || "") + " ps-mobile-studio-progress").trim()); tx.move(progress, panel, orderHeading); }
    const tiers = document.getElementById("studio-tiers");
    const summary = panel.querySelector(".summary-lock");
    const review = document.getElementById("review");
    const anchor = summary || review;
    if (tiers && anchor && anchor.parentNode === panel) tx.move(tiers, panel, anchor.nextSibling);
    layouts.studio = tx;
  }

  function product() {
    const host = document.getElementById("product-page");
    const detail = host && host.querySelector(".catalog-detail");
    if (layouts.product && layouts.product.owner !== detail) release("product");
    if (!detail || layouts.product) return;
    const info = detail.querySelector(".catalog-detail-info");
    const photo = detail.querySelector(".catalog-detail-photo");
    const color = info && info.querySelector('label[for="catalog-color"], label[for="pending-color"]');
    /* Skip incomplete/nonstandard templates instead of changing their purchase behavior. */
    if (!info || !photo || !color) return;
    const tx = transaction(detail);
    tx.className(detail, "ps-mobile-product");
    tx.move(photo, info, color);
    const tiers = info.querySelector("#modal-tiers");
    const note = info.querySelector(".catalog-ordering-note");
    const action = info.querySelector("#catalog-purchase-alternative") || info.querySelector("#catalog-customize");
    const anchor = note || action;
    if (tiers && anchor && anchor.parentNode === info) tx.move(tiers, info, anchor.nextSibling);
    layouts.product = tx;
  }

  function observeProduct() {
    const host = document.getElementById("product-page");
    if (host === productHost) return;
    if (productObserver) productObserver.disconnect();
    productHost = host;
    productObserver = null;
    if (host) {
      productObserver = new MutationObserver(refresh);
      /* The product module replaces this host; inner price/gallery updates need no reordering. */
      productObserver.observe(host, { childList: true });
    }
  }

  function reconcile() {
    frame = 0;
    if (destroyed || !document.body) return;
    observeProduct();
    const focused = document.activeElement;
    if (media.matches) {
      document.documentElement.classList.add("ps-mobile-order-active");
      home();
      catalog();
      product();
    } else {
      ["product", "catalog", "home"].forEach(release);
      clearRootClass();
    }
    if (compactMedia.matches) {
      document.documentElement.classList.add("ps-mobile-customizer-active");
      header();studio();
    } else {
      ["studio", "header"].forEach(release);
      document.documentElement.classList.remove("ps-mobile-customizer-active");
      if (!rootHadClassAttribute && !document.documentElement.getAttribute("class")) document.documentElement.removeAttribute("class");
    }
    if (focused && focused !== document.body && focused.isConnected && document.activeElement !== focused && typeof focused.focus === "function" && focused.getClientRects().length) {
      focused.focus({ preventScroll: true });
    }
  }

  function refresh() {
    if (!destroyed && !frame) frame = window.requestAnimationFrame(reconcile);
  }

  function listen(target, name, callback) {
    target.addEventListener(name, callback);
    listeners.push(function () { target.removeEventListener(name, callback); });
  }

  function destroy() {
    if (destroyed) return;
    destroyed = true;
    if (frame) window.cancelAnimationFrame(frame);
    if (productObserver) productObserver.disconnect();
    listeners.forEach(function (remove) { remove(); });
    ["product", "studio", "catalog", "home", "header"].forEach(release);
    document.documentElement.classList.remove("ps-mobile-customizer-active");
    clearRootClass();
    if (window.PS_MOBILE_ORDER === api) delete window.PS_MOBILE_ORDER;
  }

  const api = { version: "20261027", refresh: refresh, destroy: destroy };
  window.PS_MOBILE_ORDER = api;
  if (typeof media.addEventListener === "function") listen(media, "change", refresh);
  else {
    media.addListener(refresh);
    listeners.push(function () { media.removeListener(refresh); });
  }
  if (typeof compactMedia.addEventListener === "function") listen(compactMedia, "change", refresh);
  else { compactMedia.addListener(refresh); listeners.push(function () { compactMedia.removeListener(refresh); }); }
  listen(window, "hashchange", refresh);
  listen(window, "popstate", refresh);
  listen(window, "pageshow", refresh);
  listen(window, "load", refresh);
  listen(document, "shopify:section:load", refresh);
  if (document.readyState === "loading") listen(document, "DOMContentLoaded", refresh);
  refresh();
})();
